export function t(str: string, tokens: Record<string, string>) {
  return Object.keys(tokens).reduce(
    (res, token) => res.replaceAll(`:${token}`, tokens[token]),
    str
  );
}
